<template lang="pug">
h1.title-main.text-title
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

/**
 * タイトル(h1要素)
 */
@Component
export default class TitleMain extends Vue {}
</script>

<style lang="stylus" scoped></style>
